module.exports = __webpack_public_path__ + "img/vectors.8a4bd094.png";